export const GAME_CATALOG_UPDATED = 'winningdays/game-catalog/GAME_CATALOG_UPDATED'
export const GAME_CATALOG_CATEGORIES_UPDATED =
  'winningdays/game-catalog/GAME_CATALOG_CATEGORIES_UPDATED'
export const GAME_CATALOG_SECTIONS_UPDATED =
  'winningdays/game-catalog/GAME_CATALOG_SECTIONS_UPDATED'
export const GAME_CATALOG_GAMES_UPDATED =
  'winningdays/game-catalog/GAME_CATALOG_GAMES_UPDATED'
